export const SINGLE_BUY_CART_ERROR_MESSAGE =
  "A replenishment plan can contain buy legs for only one supplier and ship-to warehouse";

interface BuyCartPlanLeg {
  legType: string;
  supplierId?: string | null;
  shipToWarehouseId?: string | null;
}

const normalizeId = (id: string): string => id.toLowerCase();

export function hasAtMostOneExplicitBuyCart(
  legs: readonly BuyCartPlanLeg[],
): boolean {
  const supplierIds = new Set<string>();
  const shipToWarehouseIds = new Set<string>();

  for (const leg of legs) {
    if (leg.legType !== "buy") continue;
    if (leg.supplierId) supplierIds.add(normalizeId(leg.supplierId));
    if (leg.shipToWarehouseId) {
      shipToWarehouseIds.add(normalizeId(leg.shipToWarehouseId));
    }
  }

  return supplierIds.size <= 1 && shipToWarehouseIds.size <= 1;
}

export function hasAtMostOneResolvedBuyCart(
  legs: readonly BuyCartPlanLeg[],
): boolean {
  const buyLegs = legs.filter((leg) => leg.legType === "buy");
  return (
    buyLegs.every(
      (leg) => leg.supplierId != null && leg.shipToWarehouseId != null,
    ) && hasAtMostOneExplicitBuyCart(buyLegs)
  );
}
